import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sounds/start.mp3")